import React, { useState } from 'react';

import { Button } from 'components/v2/Buttons/Button/Button';
import PostopInstructionsModal from 'screens/MyJourney/details/PostopInstructionsModal';
import { StepDescription } from 'screens/MyJourney/details/StepDescription';
import { Description } from 'screens/MyJourney/details/StepDetail';
import styled from 'styled-components';

export const RetrievalDetail = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <StepDescription
        description={
          <>
            <FlexContainer>
              <Description>
                Once your provider determines you&apos;re ready, they&apos;ll instruct you to take a
                trigger shot. 35 hours later, we will retrieve your eggs.
              </Description>
              <ButtonStyled
                label="Review Post-Op Instructions"
                onClick={() => setShowModal(!showModal)}
              />
            </FlexContainer>
          </>
        }
      />
      <PostopInstructionsModal show={showModal} hide={() => setShowModal(false)} />
    </>
  );
};

const ButtonStyled = styled(Button)`
  min-width: fit-content;
  height: fit-content;
  margin-bottom: 20px;
`;

const FlexContainer = styled.div`
  display: flex;

  @media ${({ theme }) => theme.queries.minLargeDesktop} {
    flex-wrap: wrap;
  }
`;
